import { PagingOptions } from '../../interfaces/options';

export const DefaultPagingOptions: PagingOptions = {
	pageSize: 14
};
